// extracted by mini-css-extract-plugin
export default {"card":"U3-z"};